import React from "react";
import { TableTheadProps } from "./Table.types";
import { Thead as StyledThead } from "./Thead.styles";

/**
 * Table header component
 */
export const Thead = ({
  children,
  hasBorderBottom,
  className
}: TableTheadProps) => (
  <StyledThead hasBorderBottom={hasBorderBottom} className={className}>
    {children}
  </StyledThead>
);
